import {
  AssetData,
  PrintAttributeDefinition,
  PrintAttributeSavePayload,
} from './print-attribute.model';

export interface EventPrintAttributeDefinition extends PrintAttributeDefinition {
  Id?: string;
  EventId?: string;
  EventName?: string;
  EventTypeIds?: string[];
  EventTypeNames?: string;
  DivisionIds?: string[];
  DivisionNames?: string;
  VersionIds?: string[];
  VersionNames?: string;
  PrintPageId?: string;
  PrintPage?: string;
  Position?: number;
  EventOnlyAttribute?: boolean;
}

export interface EventPrintAttributeSavePayload {
  Detail: PrintAttributeSavePayload['Detail'];
  Data: any;
  EventId: string;
  EventTypeId: string;
  DivisionIds: string[];
  EventTypeName?: string;
  DivisionNames?: string;
  BannerId?: string;
  BannerName?: string;
  AssetId?: string;
  AssetData?: AssetData;
  VersionIds?: string[];
  PrintPageId?: string;
  Position?: number | null;
}
